export class DocumentRequestDto {
  webDokuId = "";
  documentId = "";
}
